// extracted by mini-css-extract-plugin
export default {"wrapper":"f0-z","play":"g0-z"};